import { ADMIN_MODAL_FORMS } from '../../constants/actions';
import { apiActionCreator } from '../helpers';
import { BAD_REQUEST_CODE } from '../../constants/http.codes';
import { apiMultipleCalls } from '../helpers';
import { omit } from 'lodash';
import { clearNullValues } from '../../lib/collection.utils';

export function openModalForm() {
    return {
        type: ADMIN_MODAL_FORMS.OPEN
    };
}

export function openModalFormWithData(model, data) {
    const item = clearNullValues(data);
    return {
        type: ADMIN_MODAL_FORMS.INITIALIZE,
        model,
        item
    };
}

export function modalFormSetField(value, field) {
    return {
        type: ADMIN_MODAL_FORMS.SET,
        field,
        value
    };
}

export function closeModalForm() {
    return {
        type: ADMIN_MODAL_FORMS.CLOSE
    };
}

export function onInput(model, field, value) {
    return {
        type: ADMIN_MODAL_FORMS.INPUT,
        model,
        field,
        value
    };
}

export function fetchDependencies(apiCalls) {
    return async (dispatch, getState) => {
        dispatch({ type: ADMIN_MODAL_FORMS.FETCH_START, dependencies: true });
        apiMultipleCalls(dispatch, apiCalls, results => {
            dispatch({
                type: ADMIN_MODAL_FORMS.FETCH_OK,
                model: 'dependencies',
                dependencies: true,
                data: omit(results, 'totalResults')
            });
        });
    };
}

export function submit(submitFunction, options = {}) {
    return async (dispatch, getState) => {
        dispatch({ type: ADMIN_MODAL_FORMS.SUBMIT });
        await apiActionCreator(
            dispatch,
            submitFunction,
            () => {
                const doneFunction = () => dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
                options.beforeDone ? options.beforeDone(dispatch, getState, doneFunction) : doneFunction();
            },
            {
                [BAD_REQUEST_CODE]: e => {
                    dispatch({ type: ADMIN_MODAL_FORMS.FAILED, error: e.message });
                }
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/actions/admin/modal.forms.js